import React, { useState } from 'react';
import { UserIcon, MailIcon, PhoneIcon, MapPinIcon, CalendarIcon, TagIcon, ClipboardIcon, CreditCardIcon, CompassIcon, Edit2Icon, MoreHorizontalIcon, PlusIcon, ChevronDownIcon, ChevronUpIcon, MessageSquareIcon } from 'lucide-react';
import { CustomerTransactions } from './CustomerTransactions';
import { CustomerBrowsingHistory } from './CustomerBrowsingHistory';
import { CustomerPreferences } from './CustomerPreferences';
interface CustomerProfileProps {
  customer: any;
}
export const CustomerProfile: React.FC<CustomerProfileProps> = ({
  customer
}) => {
  const [activeTab, setActiveTab] = useState('overview');
  const [note, setNote] = useState('');
  const [showAllPreferences, setShowAllPreferences] = useState(false);
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };
  const handleAddNote = () => {
    if (note.trim()) {
      console.log('Adding note:', note);
      // In a real app, this would save the note to the customer record
      setNote('');
    }
  };
  const handleCreateQuote = () => {
    console.log('Creating quote for customer:', customer.id);
    // In a real app, this would navigate to the quote creation page
  };
  const handleScheduleFollowUp = () => {
    console.log('Scheduling follow-up for customer:', customer.id);
    // In a real app, this would open a scheduling dialog
  };
  return <div className="flex flex-col h-full" data-id="element-1858">
      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-1859">
        <div className="flex" data-id="element-1860">
          <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'overview' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('overview')} data-id="element-1861">
            Overview
          </button>
          <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'transactions' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('transactions')} data-id="element-1862">
            Transactions
          </button>
          <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'browsing' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('browsing')} data-id="element-1863">
            Browsing History
          </button>
          <button className={`px-4 py-3 text-sm font-medium ${activeTab === 'preferences' ? 'border-b-2 border-blue-500 text-blue-600' : 'text-gray-500 hover:text-gray-700'}`} onClick={() => setActiveTab('preferences')} data-id="element-1864">
            Preferences
          </button>
        </div>
      </div>
      {/* Tab content */}
      <div className="flex-1 overflow-auto" data-id="element-1865">
        {activeTab === 'overview' && <div className="p-6" data-id="element-1866">
            {/* Customer header */}
            <div className="border-b border-gray-200 pb-6" data-id="element-1867">
              <div className="flex justify-between items-start" data-id="element-1868">
                <div className="flex items-center" data-id="element-1869">
                  <div className="h-16 w-16 rounded-full bg-gray-200 flex items-center justify-center text-gray-600 text-xl font-medium" data-id="element-1870">
                    {customer.firstName.charAt(0)}
                    {customer.lastName.charAt(0)}
                  </div>
                  <div className="ml-4" data-id="element-1871">
                    <h2 className="text-xl font-bold text-gray-800" data-id="element-1872">
                      {customer.firstName} {customer.lastName}
                    </h2>
                    <p className="text-gray-500" data-id="element-1873">
                      {customer.type === 'repeat' ? 'Repeat Customer' : 'New Customer'}
                    </p>
                  </div>
                </div>
                <div className="flex space-x-2" data-id="element-1874">
                  <button className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100" data-id="element-1875">
                    <Edit2Icon className="h-5 w-5" data-id="element-1876" />
                  </button>
                  <button className="p-2 text-gray-500 hover:text-gray-700 rounded-full hover:bg-gray-100" data-id="element-1877">
                    <MoreHorizontalIcon className="h-5 w-5" data-id="element-1878" />
                  </button>
                </div>
              </div>
              <div className="mt-6 grid grid-cols-2 gap-4" data-id="element-1879">
                <div className="flex items-start" data-id="element-1880">
                  <MailIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-1881" />
                  <div data-id="element-1882">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1883">Email</p>
                    <p className="text-gray-800" data-id="element-1884">{customer.email}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1885">
                  <PhoneIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-1886" />
                  <div data-id="element-1887">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1888">Phone</p>
                    <p className="text-gray-800" data-id="element-1889">{customer.phone}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1890">
                  <MapPinIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-1891" />
                  <div data-id="element-1892">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1893">Address</p>
                    <p className="text-gray-800" data-id="element-1894">{customer.address}</p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-1895">
                  <CalendarIcon className="h-5 w-5 text-gray-400 mt-0.5 mr-2" data-id="element-1896" />
                  <div data-id="element-1897">
                    <p className="text-sm font-medium text-gray-500" data-id="element-1898">
                      Last Contact
                    </p>
                    <p className="text-gray-800" data-id="element-1899">
                      {formatDate(customer.lastContact)}
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6" data-id="element-1900">
                <p className="text-sm font-medium text-gray-500 mb-2" data-id="element-1901">Tags</p>
                <div className="flex flex-wrap gap-2" data-id="element-1902">
                  {customer.tags.map((tag: string) => <span key={tag} className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800" data-id="element-1903">
                      {tag}
                    </span>)}
                </div>
              </div>
              <div className="mt-6 flex space-x-3" data-id="element-1904">
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors" onClick={handleCreateQuote} data-id="element-1905">
                  Create Quote
                </button>
                <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={handleScheduleFollowUp} data-id="element-1906">
                  Schedule Follow-up
                </button>
              </div>
            </div>
            {/* Summary Sections */}
            <div className="pt-6 grid grid-cols-2 gap-6" data-id="element-1907">
              {/* Transaction Summary */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1908">
                <div className="flex justify-between items-center mb-4" data-id="element-1909">
                  <h3 className="text-md font-medium text-gray-800 flex items-center" data-id="element-1910">
                    <CreditCardIcon className="h-4 w-4 text-blue-500 mr-2" data-id="element-1911" />
                    Transaction Summary
                  </h3>
                  <button className="text-sm text-blue-600 hover:text-blue-800" onClick={() => setActiveTab('transactions')} data-id="element-1912">
                    View All
                  </button>
                </div>
                <div className="space-y-3" data-id="element-1913">
                  {customer.transactions.slice(0, 2).map((transaction: any) => <div key={transaction.id} className="flex justify-between items-center p-2 border-b border-gray-100" data-id="element-1914">
                      <div data-id="element-1915">
                        <p className="text-sm font-medium text-gray-800" data-id="element-1916">
                          {transaction.product}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-1917">
                          {formatDate(transaction.date)}
                        </p>
                      </div>
                      <span className={`font-medium ${transaction.type === 'refund' ? 'text-red-600' : 'text-green-600'}`} data-id="element-1918">
                        {transaction.type === 'refund' ? '-' : ''}$
                        {Math.abs(transaction.amount)}
                      </span>
                    </div>)}
                </div>
              </div>
              {/* Browsing Summary */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1919">
                <div className="flex justify-between items-center mb-4" data-id="element-1920">
                  <h3 className="text-md font-medium text-gray-800 flex items-center" data-id="element-1921">
                    <CompassIcon className="h-4 w-4 text-blue-500 mr-2" data-id="element-1922" />
                    Recent Browsing
                  </h3>
                  <button className="text-sm text-blue-600 hover:text-blue-800" onClick={() => setActiveTab('browsing')} data-id="element-1923">
                    View All
                  </button>
                </div>
                <div className="space-y-3" data-id="element-1924">
                  {customer.browsingHistory.slice(0, 3).map((item: any) => <div key={item.id} className="flex justify-between items-center p-2 border-b border-gray-100" data-id="element-1925">
                      <div data-id="element-1926">
                        <p className="text-sm font-medium text-gray-800" data-id="element-1927">
                          {item.page}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-1928">
                          {formatDate(item.date)}
                        </p>
                      </div>
                      <span className="text-xs text-gray-500" data-id="element-1929">
                        {item.duration}
                      </span>
                    </div>)}
                </div>
              </div>
              {/* Preferences Summary */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1930">
                <div className="flex justify-between items-center mb-4" data-id="element-1931">
                  <h3 className="text-md font-medium text-gray-800 flex items-center" data-id="element-1932">
                    <TagIcon className="h-4 w-4 text-blue-500 mr-2" data-id="element-1933" />
                    Travel Preferences
                  </h3>
                  <button className="text-sm text-blue-600 hover:text-blue-800" onClick={() => setActiveTab('preferences')} data-id="element-1934">
                    View All
                  </button>
                </div>
                <div className="space-y-2" data-id="element-1935">
                  <div className="flex items-start" data-id="element-1936">
                    <p className="text-sm font-medium text-gray-700 w-1/3" data-id="element-1937">
                      Destinations:
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1938">
                      {customer.preferences.destinations.join(', ')}
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-1939">
                    <p className="text-sm font-medium text-gray-700 w-1/3" data-id="element-1940">
                      Travel Style:
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1941">
                      {customer.preferences.travelStyle}
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-1942">
                    <p className="text-sm font-medium text-gray-700 w-1/3" data-id="element-1943">
                      Budget:
                    </p>
                    <p className="text-sm text-gray-600" data-id="element-1944">
                      {customer.preferences.budget}
                    </p>
                  </div>
                </div>
              </div>
              {/* Notes */}
              <div className="border border-gray-200 rounded-lg p-4" data-id="element-1945">
                <h3 className="text-md font-medium text-gray-800 flex items-center mb-4" data-id="element-1946">
                  <ClipboardIcon className="h-4 w-4 text-blue-500 mr-2" data-id="element-1947" />
                  Notes
                </h3>
                <p className="text-sm text-gray-700 mb-4" data-id="element-1948">{customer.notes}</p>
                <div className="mt-2" data-id="element-1949">
                  <textarea className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-sm" rows={2} placeholder="Add a note..." value={note} onChange={e => setNote(e.target.value)} data-id="element-1950"></textarea>
                  <div className="mt-2 flex justify-end" data-id="element-1951">
                    <button className="px-3 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700 transition-colors" onClick={handleAddNote} data-id="element-1952">
                      Add Note
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>}
        {activeTab === 'transactions' && <CustomerTransactions transactions={customer.transactions} data-id="element-1953" />}
        {activeTab === 'browsing' && <CustomerBrowsingHistory browsingHistory={customer.browsingHistory} data-id="element-1954" />}
        {activeTab === 'preferences' && <CustomerPreferences preferences={customer.preferences} data-id="element-1955" />}
      </div>
    </div>;
};